import 'babel-polyfill'
import 'event-source-polyfill'
import Vue from 'vue'
import { Menu, MenuItem, Submenu, MessageBox, Breadcrumb, BreadcrumbItem, Loading, Row, Col, Table, TableColumn, Form, FormItem, Button, ButtonGroup, Badge, Tree, Pagination, Dialog, Select, Option, Cascader, Input, Alert, Tag, Checkbox, CheckboxGroup, Tooltip, Switch, Radio, RadioGroup, Tabs, TabPane, Upload, DatePicker } from "element-ui"
import ScrollBar from 'vue2-scrollbar'
import "vue2-scrollbar/dist/style/vue2-scrollbar.css"
import './less/font-awesome.less'
import './less/common.less'
import LyComponents from './components/index'
import messages from './utils/message'
import openService from './utils/open-service'

import App from './App'
import router from './router'
import store from './store'
import { setToken } from './utils/auth'

Vue.config.productionTip = false
Vue.use(Loading);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Submenu);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Row);
Vue.use(Col);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Badge);
Vue.use(Tree);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Select);
Vue.use(Option);
Vue.use(Cascader);
Vue.use(Input);
Vue.use(Alert);
Vue.use(Tag);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Tooltip);
Vue.use(Switch);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Upload);
Vue.use(DatePicker);
Vue.use(LyComponents);

Vue.component('vueScrollbar', ScrollBar);

Vue.prototype.$message = messages;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$openService = openService;
//herong
Vue.prototype.$msgbox = MessageBox;
// 不重定向白名单
const whiteList = ['/login', '/recover']; // 忘记密码

router.beforeEach((to, from, next) => {
  store.dispatch('SET_OBJAPI').then((res) => {
    document.title = store.state.api.PLATFORM_NAME ? store.state.api.PLATFORM_NAME: '大装备一体化管理服务云平台';
    store.dispatch('GetToken').then(res => {
      if (store.getters.token) { // 有token
        if (to.name === 'login') {
          next({name: 'platform'});
        } else {
          if (to.meta.powerBtn) {
            if (store.getters.powerBtn) {
              next();
            } else {
              store.dispatch('GetPowerBtn').then(() => {
                next();
              });
            }
            let treeStatus = to.name === 'organization';
            store.commit('SET_TREE_OPER', treeStatus);
          } else {
            to.name ? next() : next({ name: 'platform' });
          }
        }
      } else if (whiteList.indexOf(to.path) !== -1) { // 白名单
        next();
      } else if (to.hash.indexOf("access_token") !== -1) { // setToken
        setToken(to.hash);
      } else { // 无token
        next({name: 'login'});
      }
    })
  })
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js